class MCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartDrawerInner = this.querySelector(".m-cart-drawer__inner");
    this.cartDrawerCloseIcon = this.querySelector(".m-cart-drawer__close");
    this.cartOverlay = this.querySelector(".m-cart__overlay");
    this.rootUrl = window.Shopify.routes.root;

    this.setHeaderCartIconAccessibility();
    this.cartDrawerCloseIcon.addEventListener("click", this.close.bind(this));
    this.addEventListener("click", (event) => {
      if (event.target.closest(".m-cart-drawer__inner") !== this.cartDrawerInner) {
        this.close();
      }
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll(".m-cart-icon-bubble");
    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.classList.add("m-cart-drawer--active");
    requestAnimationFrame(() => {
      this.style.setProperty("--m-bg-opacity", "0.5");
      this.cartDrawerInner.style.setProperty("--translate-x", "0");
    });
    window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);
    document.documentElement.classList.add("prevent-scroll");
  }

  close() {
    this.style.setProperty("--m-bg-opacity", "0");
    this.cartDrawerInner.style.setProperty("--translate-x", "100%");
    setTimeout(() => {
      this.classList.remove("m-cart-drawer--active");
      document.documentElement.classList.remove("prevent-scroll");
    }, 300);
  }

  renderContents(parsedState) {
    this.classList.contains("m-cart--empty") && this.classList.remove("m-cart--empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    setTimeout(() => {
      this.open();
    });
  }

  updateCartCount(itemCount) {
    const cartCounts = document.querySelectorAll(".m-cart-count-bubble");
    cartCounts.forEach((cartCount) => {
      if (itemCount > 0) {
        cartCount.textContent = itemCount;
        cartCount.classList.remove("m:hidden");
      } else {
        cartCount.classList.add("m:hidden");
      }
    });
  }

  getCart() {
    return fetchJSON(this.rootUrl + "cart.json");
  }

  onCartDrawerUpdate(updateFooter = true) {
    fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        this.getSectionsToRender().forEach((section) => {
          if (section.block === "cart-items") {
            const sectionElement = section.selector
              ? document.querySelector(section.selector)
              : document.getElementById(section.id);
            sectionElement.innerHTML = this.getSectionInnerHTML(responseText, section.selector);
          } else {
            if (updateFooter) {
              const sectionElement = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);
              sectionElement.innerHTML = this.getSectionInnerHTML(responseText, section.selector);
            }
          }
        });
      })
      .catch((e) => {
        console.error(e);
      });
    this.getCart().then((cart) => {
      this.classList.toggle("m-cart--empty", cart.item_count === 0);
      this.updateCartCount(cart.item_count);
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "[data-minimog-cart-items]",
        block: "cart-items",
      },
      {
        id: "cart-drawer",
        selector: "[data-minimog-cart-discounts]",
        block: "cart-footer",
      },
      {
        id: "cart-drawer",
        selector: "[data-cart-subtotal]",
        block: "cart-footer",
      },
      {
        id: "cart-drawer",
        selector: "[data-minimog-gift-wrapping]",
        block: "cart-footer",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // Free Product add logic

  removeSpecialProductFromCartItems() {
    // No longer needed since we removed the offer box
  }

  async removeSpecialProductFromCart() {
    console.log('[CartDrawer] Starting removal of special product...');

    // Check if special product is in cart
    if (!this.isSpecialProductInCart()) {
      console.log('[CartDrawer] Special product not in cart, skipping removal');
      return;
    }

    try {
      // Get both variant IDs for the special product
      const freeVariantId = '51934484169004'; // Free variant ID
      const paidVariantId = '51934484136236'; // Paid variant ID
      const specialProductId = '10079895355692'; // Stud Earrings product ID

      console.log('[CartDrawer] Looking for special product in cart items...');

      // Find the cart item with the special product
      const cartItems = this.querySelectorAll('.m-cart-item');
      let specialItemKey = null;
      let specialItemIndex = null;

      for (let i = 0; i < cartItems.length; i++) {
        const item = cartItems[i];
        let isSpecialItem = false;

        // Check by variant ID (both free and paid variants)
        const variantIdElement = item.querySelector('[data-variant-id]');
        if (variantIdElement) {
          const variantId = variantIdElement.getAttribute('data-variant-id');
          console.log(`[CartDrawer] Checking item ${i + 1} variant ID: ${variantId}`);
          if (variantId === freeVariantId || variantId === paidVariantId) {
            isSpecialItem = true;
            console.log('[CartDrawer] Found special item by variant ID');
          }
        }

        // Check by product ID
        const productId = item.getAttribute('data-product-id');
        if (productId === specialProductId) {
          isSpecialItem = true;
          console.log('[CartDrawer] Found special item by product ID');
        }

        if (isSpecialItem) {
          // Try to get the item key
          const itemKey = item.getAttribute('data-key');
          if (itemKey) {
            specialItemKey = itemKey;
            console.log(`[CartDrawer] Found item key: ${itemKey}`);
            break;
          }

          // If no key, try to get from data-index
          const itemIndex = item.getAttribute('data-index');
          if (itemIndex) {
            specialItemIndex = itemIndex;
            console.log(`[CartDrawer] Found item index: ${itemIndex}`);
            break;
          }

          // If no index, use the loop index
          specialItemIndex = i.toString();
          console.log(`[CartDrawer] Using loop index: ${specialItemIndex}`);
          break;
        }
      }

      if (specialItemKey) {
        console.log(`[CartDrawer] Removing item with key: ${specialItemKey}`);

        // Remove using item key
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: specialItemKey,
            quantity: 0
          })
        });

        if (response.ok) {
          const result = await response.json();
          console.log('[CartDrawer] Successfully removed special product via API');
          this.updateCartAfterRemoval();
        } else {
          console.error('[CartDrawer] Failed to remove special product from cart:', response.status);
          // Try fallback method
          await this.fallbackRemoveSpecialProduct();
        }
      } else if (specialItemIndex !== null) {
        console.log(`[CartDrawer] No item key found, trying fallback method with index: ${specialItemIndex}`);
        // Try to remove using index
        await this.fallbackRemoveSpecialProduct();
      } else {
        console.log('[CartDrawer] No special item found, trying fallback method');
        await this.fallbackRemoveSpecialProduct();
      }

    } catch (error) {
      console.error('[CartDrawer] Error removing special product from cart:', error);
      // Try fallback method
      await this.fallbackRemoveSpecialProduct();
    }
  }

  async fallbackRemoveSpecialProduct() {

    try {
      // Get current cart data
      const response = await fetch('/cart.js');
      if (!response.ok) {
        console.error('Failed to fetch cart data for fallback removal');
        return;
      }

      const cartData = await response.json();

      // Find the special product in cart data (any variant)
      const freeVariantId = '51934484169004'; // Free variant ID
      const paidVariantId = '51934484136236'; // Paid variant ID
      const specialItem = cartData.items.find(item =>
        item.variant_id.toString() === freeVariantId ||
        item.variant_id.toString() === paidVariantId
      );

      if (specialItem) {

        // Remove using the key from cart data
        const removeResponse = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: specialItem.key,
            quantity: 0
          })
        });

        if (removeResponse.ok) {
          const result = await removeResponse.json();
          this.updateCartAfterRemoval();
        } else {
          console.error('Fallback removal also failed:', removeResponse.status);
        }
      }

    } catch (error) {
      console.error('Error in fallback removal method:', error);
    }
  }

  updateCartAfterRemoval() {
    console.log('[CartDrawer] Updating cart after removal...');

    // Force immediate cart refresh with multiple methods
    this.forceImmediateCartRefresh();

    // Reset flags after successful removal
    this.isAddingSpecialProduct = false;
    this.isAddingProductToCartItems = false;
    this.isLoadingProductDetails = false;
    this.lastSpecialProductAddTime = null;
    this.lastProductAddTime = null;
  }

  // New method for immediate cart refresh
  async forceImmediateCartRefresh() {
    console.log('[CartDrawer] Forcing immediate cart refresh...');

    try {
      // Method 1: Direct cart drawer update
      this.onCartDrawerUpdate(true);

      // Method 2: Force refresh the entire cart drawer
      setTimeout(() => {
        this.refreshCartDrawer();
      }, 100);

      // Method 3: Trigger MinimogEvents if available
      if (window.MinimogEvents && MinimogTheme.pubSubEvents) {
        setTimeout(() => {
          window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate);
        }, 200);
      }

      // Method 4: Force DOM update by temporarily hiding/showing cart items
      setTimeout(() => {
        this.forceDOMUpdate();
      }, 300);

    } catch (error) {
      console.error('[CartDrawer] Error in forceImmediateCartRefresh:', error);
    }
  }

  // Force DOM update by manipulating cart items visibility
  forceDOMUpdate() {
    console.log('[CartDrawer] Forcing DOM update...');

    const cartItemsContainer = this.querySelector('[data-minimog-cart-items]');
    if (cartItemsContainer) {
      // Temporarily hide and show to force re-render
      cartItemsContainer.style.opacity = '0.5';
      setTimeout(() => {
        cartItemsContainer.style.opacity = '1';
        // Trigger a reflow
        cartItemsContainer.offsetHeight;
      }, 50);
    }
  }

  async addSpecialProductToCart(productDetails) {

    try {
      // Extract variant ID from the product details
      const variantId = productDetails.variantId.split('/').pop(); // Get the numeric ID

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      if (response.ok) {
        const result = await response.json();

        // Update cart drawer
        this.onCartDrawerUpdate(true);

        // Show success message
        this.showAddToCartSuccess();

      } else {
        console.error('Failed to add product to cart:', response.status);
        this.showAddToCartError();
      }
    } catch (error) {
      console.error('Error adding product to cart:', error);
      this.showAddToCartError();
    }
  }

  showAddToCartSuccess() {
    // You can implement a success notification here
  }

  showAddToCartError() {
    // You can implement an error notification here
  }

  isSpecialProductInCart() {
    console.log('[CartDrawer] Checking if special product is in cart...');

    // Check if any free product is already in the cart
    const cartItems = this.querySelectorAll('.m-cart-item');
    const freeProductsConfig = this.getFreeProductsConfig();

    console.log(`[CartDrawer] Checking ${cartItems.length} cart items for special product`);

    for (let i = 0; i < cartItems.length; i++) {
      const item = cartItems[i];
      console.log(`[CartDrawer] Checking item ${i + 1}:`, item);

      // Check data-variant-id attribute for free product variants
      const variantIdElement = item.querySelector('[data-variant-id]');
      if (variantIdElement) {
        const variantId = variantIdElement.getAttribute('data-variant-id');
        console.log(`[CartDrawer] Item ${i + 1} variant ID: ${variantId}`);
        if (variantId && this.isFreeProductVariant(variantId)) {
          console.log('[CartDrawer] Found special product by variant ID');
          return true;
        }
      }

      // Check data-product-id attribute
      const productId = item.getAttribute('data-product-id');
      if (productId) {
        console.log(`[CartDrawer] Item ${i + 1} product ID: ${productId}`);
        for (let configVariantId in freeProductsConfig) {
          if (freeProductsConfig[configVariantId].productId === productId) {
            console.log('[CartDrawer] Found special product by product ID');
            return true;
          }
        }
      }

      // Check if the item ID contains any free product variant ID
      const itemId = item.getAttribute('id');
      if (itemId) {
        console.log(`[CartDrawer] Item ${i + 1} ID: ${itemId}`);
        for (let configVariantId in freeProductsConfig) {
          if (itemId.includes(configVariantId)) {
            console.log('[CartDrawer] Found special product by item ID');
            return true;
          }
        }
      }

      // Additional check: look for specific variant ID in any data attribute
      const allDataAttributes = item.querySelectorAll('[data-variant-id="51934484169004"]');
      if (allDataAttributes.length > 0) {
        console.log('[CartDrawer] Found special product by direct variant ID selector');
        return true;
      }

      // Check cart item text content for product name
      const itemText = item.textContent.toLowerCase();
      if (itemText.includes('stud earrings') && itemText.includes('free')) {
        console.log('[CartDrawer] Found special product by text content');
        return true;
      }
    }

    console.log('[CartDrawer] Special product not found in cart');
    return false;
  }

  // Switch to free variant when conditions are met
  async switchToFreeVariant() {

    try {
      // Get current cart data
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();

      // Find the paid variant in cart
      const paidVariantId = '51934484136236'; // Regular Stud Earrings variant
      const freeVariantId = '51934484169004'; // Free variant ID

      const paidItem = cartData.items.find(item =>
        item.variant_id.toString() === paidVariantId
      );

      if (paidItem) {

        // Remove the paid variant
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: paidItem.key,
            quantity: 0
          })
        });

        // Add the free variant
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: freeVariantId,
            quantity: 1
          })
        });

        if (addResponse.ok) {
          // Update pricing display
          this.updateSpecialProductPricing(true);
          // Force cart update to refresh detection
          setTimeout(() => {
            this.onCartDrawerUpdate(true);
          }, 500);
          return true;
        } else {
          console.error('Failed to switch to free variant:', addResponse.status);
          return false;
        }
      }
    } catch (error) {
      console.error('Error switching to free variant:', error);
      return false;
    }
  }

  // Switch back to paid variant when conditions are not met
  async switchToPaidVariant() {

    try {
      // Get current cart data
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();

      // Find the free variant in cart
      const freeVariantId = '51934484169004'; // Free variant ID
      const paidVariantId = '51934484136236'; // Regular Stud Earrings variant

      const freeItem = cartData.items.find(item =>
        item.variant_id.toString() === freeVariantId
      );

      if (freeItem) {

        // Remove the free variant
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: freeItem.key,
            quantity: 0
          })
        });

        // Add the paid variant
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: paidVariantId,
            quantity: 1
          })
        });

        if (addResponse.ok) {
          // Update pricing display
          this.updateSpecialProductPricing(false);
          return true;
        } else {
          console.error('Failed to switch back to paid variant:', addResponse.status);
          return false;
        }
      }
    } catch (error) {
      console.error('Error switching back to paid variant:', error);
      return false;
    }
  }

  async autoAddSpecialProductToCart(productDetails) {
    // Prevent multiple simultaneous additions
    if (this.isAddingSpecialProduct) {
      return;
    }

    // Check cooldown period (prevent adding within 5 seconds of last addition)
    const now = Date.now();
    if (this.lastSpecialProductAddTime && (now - this.lastSpecialProductAddTime) < 5000) {
      return;
    }

    this.isAddingSpecialProduct = true;
    this.lastSpecialProductAddTime = now;

    try {
      // Add the free variant directly - no switching needed
      const freeVariantId = '51934484169004'; // Free variant ID

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: freeVariantId,
          quantity: 1
        })
      });

      if (response.ok) {
        const result = await response.json();

        // Set flags to prevent immediate removal
        this.isUpdatingCartDrawer = true;
        this.justAddedSpecialProduct = true;

        // Simple cart update - avoid multiple simultaneous updates
        this.onCartDrawerUpdate(true);

        // Reset flags after longer delays to prevent immediate removal
        setTimeout(() => {
          this.isUpdatingCartDrawer = false;
        }, 4000);

        setTimeout(() => {
          this.justAddedSpecialProduct = false;
        }, 6000);

        this.showAutoAddSuccess();

      } else {
        console.error('Failed to automatically add free product to cart:', response.status);
        this.showAutoAddError();
      }
    } catch (error) {
      console.error('Error automatically adding free product to cart:', error);
      this.showAutoAddError();
    } finally {
      // Reset the flag after a delay
      setTimeout(() => {
        this.isAddingSpecialProduct = false;
        this.isAddingProductToCartItems = false;
        this.isLoadingProductDetails = false;
      }, 1000);
    }
  }

  showSpecialProductNotification(productDetails) {
    // No longer needed since we removed the offer box
  }

  showAutoAddSuccess() {
    // You can add a toast notification here if needed
  }

  showAutoAddError() {
    // You can add an error notification here if needed
  }

  // Hello Baba update method removed - product addition works independently

  // Optimized helper methods
  // shouldShowHelloBaba method removed - product addition works independently

  // All Hello Baba display methods removed - product addition works independently

  refreshCartDrawer() {
    // Force refresh the entire cart drawer by fetching fresh cart data
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Check if our special product is in the cart
        const specialProduct = cart.items.find(item =>
          item.variant_id === 51934484169004 ||
          item.id === 51934484169004
        );

        if (specialProduct) {
          // Free product successfully added to cart
        }

        // Trigger a complete cart drawer refresh
        this.onCartDrawerUpdate(true);
      })
      .catch(error => {
        console.error('Error refreshing cart drawer:', error);
      });
  }

  forceCartDrawerRefresh() {
    // Force a complete cart drawer refresh by closing and reopening
    // Close the cart drawer
    this.classList.remove('m-cart--open');

    // Wait a moment then reopen
    setTimeout(() => {
      this.classList.add('m-cart--open');
    }, 100);
  }

  // Free Products Configuration
  getFreeProductsConfig() {
    return {
      '51934484169004': {
        productId: '10079895355692',
        handle: 'stud-earrings',
        name: 'Stud Earrings',
        minCartTotal: 1900,
        removeThreshold: 1800,
        description: 'Free Stud Earrings when cart total >= $1900'
      }
      // Future free products can be added here:
      // 'VARIANT_ID_2': {
      //   productId: 'PRODUCT_ID_2',
      //   handle: 'product-handle-2',
      //   name: 'Product Name 2',
      //   minCartTotal: 3000,
      //   removeThreshold: 2800,
      //   description: 'Free Product 2 when cart total >= $3000'
      // }
    };
  }

  // Check if a variant is a free product
  isFreeProductVariant(variantId) {
    const config = this.getFreeProductsConfig();
    return config.hasOwnProperty(variantId);
  }

  // Get free product configuration
  getFreeProductConfig(variantId) {
    const config = this.getFreeProductsConfig();
    return config[variantId] || null;
  }

  // Enhanced method for immediate removal check (bypasses cooldown)
  async checkCartTotalForRemoval() {
    console.log('[CartDrawer] Checking cart total for immediate removal...');

    // Skip cooldown for immediate removal
    const cartItems = this.querySelectorAll('.m-cart-item');
    const hasItems = cartItems.length > 0;

    if (!hasItems) {
      console.log('[CartDrawer] No cart items found for removal check');
      return;
    }

    // Try multiple selectors for cart subtotal (same as in checkCartTotalAndAddProduct)
    const cartSubtotalElement = this.querySelector('.m-cart__subtotal [data-cart-subtotal-price]') ||
      this.querySelector('[data-cart-subtotal-price]') ||
      this.querySelector('.cart-subtotal') ||
      this.querySelector('.m-cart__subtotal .money');

    if (!cartSubtotalElement) {
      console.log('[CartDrawer] Cart subtotal element not found for removal check');
      return;
    }

    const cartTotal = cartSubtotalElement.textContent.trim();
    const cartTotalNumeric = this.parseCartTotal(cartTotal);
    console.log(`[CartDrawer] Removal check - Cart total: ${cartTotal} (numeric: ${cartTotalNumeric})`);

    // Check if special product is in cart and should be removed
    const specialProductInCart = this.isSpecialProductInCart();
    console.log(`[CartDrawer] Removal check - Special product in cart: ${specialProductInCart}`);

    if (specialProductInCart && cartTotalNumeric <= 1800) {
      console.log('[CartDrawer] Conditions met for immediate removal');
      await this.removeSpecialProductFromCart();
    } else {
      console.log('[CartDrawer] Conditions not met for removal');
    }
  }

  // Enhanced method to handle product addition based on cart total with better mobile support
  async checkCartTotalAndAddProduct() {
    console.log('[CartDrawer] checkCartTotalAndAddProduct called');

    // Add cooldown to prevent rapid calls
    const now = Date.now();
    if (this.lastCartTotalCheck && (now - this.lastCartTotalCheck) < 2000) {
      console.log('[CartDrawer] Cooldown active, skipping check');
      return;
    }
    this.lastCartTotalCheck = now;

    // Add global deduplication flag
    if (this.isProcessingCartTotal) {
      console.log('[CartDrawer] Already processing cart total, skipping');
      return;
    }

    // Prevent loop during cart drawer update
    if (this.isUpdatingCartDrawer) {
      console.log('[CartDrawer] Cart drawer updating, skipping');
      return;
    }

    this.isProcessingCartTotal = true;
    console.log('[CartDrawer] Starting cart total check...');

    try {
      // Wait for DOM to be ready (important for mobile)
      await this.waitForDOMReady();

      const cartItems = this.querySelectorAll('.m-cart-item');
      const hasItems = cartItems.length > 0;
      console.log(`[CartDrawer] Found ${cartItems.length} cart items`);

      if (!hasItems) {
        console.log('[CartDrawer] No cart items found');
        this.isProcessingCartTotal = false;
        return;
      }

      // Try multiple selectors for cart subtotal (mobile compatibility)
      const cartSubtotalElement = this.querySelector('.m-cart__subtotal [data-cart-subtotal-price]') ||
        this.querySelector('[data-cart-subtotal-price]') ||
        this.querySelector('.cart-subtotal') ||
        this.querySelector('.m-cart__subtotal .money');

      if (!cartSubtotalElement) {
        console.log('[CartDrawer] Cart subtotal element not found');
        this.isProcessingCartTotal = false;
        return;
      }

      const cartTotal = cartSubtotalElement.textContent.trim();
      const cartTotalNumeric = this.parseCartTotal(cartTotal);
      console.log(`[CartDrawer] Cart total: ${cartTotal} (numeric: ${cartTotalNumeric})`);

      // Check if special product is already in cart to prevent loops
      const specialProductInCart = this.isSpecialProductInCart();
      console.log(`[CartDrawer] Special product in cart: ${specialProductInCart}`);

      if (specialProductInCart) {
        // If special product is in cart, only remove if total is significantly below threshold
        const minimumTotal = 1800; // Lower threshold to prevent constant add/remove

        // Don't remove if we just added the product
        if (this.justAddedSpecialProduct) {
          console.log('[CartDrawer] Just added special product, skipping removal');
          return;
        }

        if (cartTotalNumeric <= minimumTotal) {
          console.log('[CartDrawer] Cart total below threshold, removing special product');
          // Reset cooldown for immediate removal
          this.lastCartTotalCheck = 0;
          await this.removeSpecialProductFromCart();
        } else {
          console.log('[CartDrawer] Cart total above threshold, keeping special product');
        }
      } else {
        // Normal threshold for adding the product
        const minimumTotal = 1900;
        if (cartTotalNumeric >= minimumTotal) {
          console.log('[CartDrawer] Cart total above threshold, adding special product');
          // Load product details and add to cart
          await this.loadProductDetails();
        } else {
          console.log(`[CartDrawer] Cart total ${cartTotalNumeric} below threshold ${minimumTotal}`);
        }
      }

    } catch (error) {
      console.error('[CartDrawer] Error in checkCartTotalAndAddProduct:', error);
    } finally {
      this.isProcessingCartTotal = false;
      console.log('[CartDrawer] Cart total check completed');

      // Add timeout to reset flag in case it gets stuck
      setTimeout(() => {
        this.isProcessingCartTotal = false;
        this.isUpdatingCartDrawer = false;
      }, 8000);
    }
  }

  // Helper method to wait for DOM to be ready (important for mobile)
  async waitForDOMReady() {
    return new Promise((resolve) => {
      if (document.readyState === 'complete') {
        resolve();
      } else {
        const checkReady = () => {
          if (document.readyState === 'complete') {
            resolve();
          } else {
            setTimeout(checkReady, 50);
          }
        };
        checkReady();
      }
    });
  }

  parseCartTotal(cartTotalString) {
    const cleanTotal = cartTotalString.replace(/[$,\s]/g, '');
    const numericMatch = cleanTotal.match(/[\d.]+/);

    if (numericMatch) {
      const numericValue = parseFloat(numericMatch[0]);
      return isNaN(numericValue) ? 0 : numericValue;
    }

    return 0;
  }

  // Product details for cart total > $1900
  async fetchProductDetails() {
    // Use the free variant directly
    const productId = 'gid://shopify/Product/10079895355692'; // Stud Earrings
    const variantId = 'gid://shopify/ProductVariant/51934484169004'; // Free variant
    const productHandle = this.getProductHandleFromId(productId);


    try {
      // Try to fetch from the product page first
      const response = await fetch(`/products/${productHandle}.js`);

      if (response.ok) {
        const product = await response.json();
        return {
          name: product.title,
          price: this.formatPrice(product.variants[0].price),
          variantId: variantId
        };
      } else {
        // Since the product is in draft, we'll use fallback data
        return {
          name: 'Stud Earrings',
          price: '$500.00',
          variantId: variantId
        };
      }
    } catch (error) {
      // Since the product is in draft, we'll use fallback data
      return {
        name: 'Stud Earrings',
        price: '$500.00',
        variantId: variantId
      };
    }

    // Fallback product details (Stud Earrings)
    return {
      name: 'Stud Earrings',
      price: '$500.00',
      variantId: variantId
    };
  }

  getProductHandleFromId(productId) {
    // Map product ID to handle
    const productHandleMap = {
      'gid://shopify/Product/10079895355692': 'stud-earrings', // Original product
      'gid://shopify/Product/10089815572780': 'free-stud-earrings-gift' // Your free product (when created)
    };

    return productHandleMap[productId] || 'stud-earrings';
  }

  formatPrice(priceInCents) {
    // Convert cents to dollars and format
    const dollars = priceInCents / 100;
    return `$${dollars.toFixed(2)}`;
  }

  async loadProductDetails() {
    // Prevent duplicate calls
    if (this.isLoadingProductDetails) {
      return;
    }

    this.isLoadingProductDetails = true;

    try {
      const productDetails = await this.fetchProductDetails();

      // Add product details to cart items section
      await this.addProductToCartItems(productDetails);

    } catch (error) {
      console.error('Error loading product details:', error);
    } finally {
      this.isLoadingProductDetails = false;
    }
  }

  // Update special product pricing display
  updateSpecialProductPricing(isDiscounted = true) {
    const currentPriceElement = this.querySelector('.special-product-current-price');
    const originalPriceElement = this.querySelector('.special-product-original-price');

    if (currentPriceElement && originalPriceElement) {
      if (isDiscounted) {
        currentPriceElement.textContent = 'FREE';
        currentPriceElement.style.color = '#4CAF50';
        originalPriceElement.style.display = 'block';
      } else {
        currentPriceElement.textContent = '$500.00';
        currentPriceElement.style.color = '#333';
        originalPriceElement.style.display = 'none';
      }
    }
  }

  // Hide free variant from product page for security
  hideFreeVariantFromProductPage() {
    // Check if we're on the Stud Earrings product page
    if (window.location.pathname.includes('/products/stud-earrings')) {
      // Hide the free variant option from the variant selector
      const freeVariantOption = document.querySelector('input[value="51934484169004"]');
      if (freeVariantOption) {
        const variantLabel = freeVariantOption.closest('label') || freeVariantOption.parentElement;
        if (variantLabel) {
          variantLabel.style.display = 'none';
        }
      }

      // Hide free variant from any dropdown selectors
      const freeVariantSelect = document.querySelector('select option[value="51934484169004"]');
      if (freeVariantSelect) {
        freeVariantSelect.style.display = 'none';
      }

      // Redirect if someone tries to access free variant directly via URL
      if (window.location.search.includes('variant=51934484169004')) {
        // Redirect to regular variant
        const newUrl = window.location.pathname + '?variant=51934484136236';
        window.history.replaceState({}, '', newUrl);

        // Show a message
        const message = document.createElement('div');
        message.style.cssText = `
          position: fixed; top: 20px; right: 20px; background: #ff6b6b; color: white;
          padding: 12px 20px; border-radius: 8px; z-index: 9999; font-weight: bold;
          box-shadow: 0 4px 12px rgba(0,0,0,0.3);
        `;
        message.textContent = 'Free gift variant is only available as a special offer!';
        document.body.appendChild(message);

        setTimeout(() => {
          message.remove();
        }, 3000);
      }
    }
  }

  async addProductToCartItems(productDetails) {
    // Check if the special product is already in the actual cart
    if (this.isSpecialProductInCart()) {
      return;
    }

    // Check if we're already in the process of adding
    if (this.isAddingProductToCartItems) {
      return;
    }

    // Add cooldown to prevent rapid additions
    const now = Date.now();
    if (this.lastProductAddTime && (now - this.lastProductAddTime) < 3000) {
      return;
    }
    this.lastProductAddTime = now;
    this.isAddingProductToCartItems = true;

    // Automatically add the special product to cart
    await this.autoAddSpecialProductToCart(productDetails);

    // Reset the flag
    this.isAddingProductToCartItems = false;

    // Add timeout to reset flags in case they get stuck
    setTimeout(() => {
      this.isAddingProductToCartItems = false;
      this.isAddingSpecialProduct = false;
      this.isLoadingProductDetails = false;
    }, 8000);
  }

}

customElements.define("m-cart-drawer", MCartDrawer);

class MCartDrawerItems extends MCartTemplate {
  getSectionsToRender() {
    return [
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-cart-items]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-cart-discounts]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-cart-subtotal]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-gift-wrapping]",
      },
    ];
  }
}

customElements.define("m-cart-drawer-items", MCartDrawerItems);

// Enhanced Cart Drawer Event Handler with Mobile Support and Debugging
class CartDrawerEventHandler {
  constructor() {
    this.cartDrawer = null;
    this.isInitialized = false;
    this.debugMode = true; // Set to false in production
    this.eventListeners = new Map();
    this.retryAttempts = 0;
    this.maxRetries = 3;

    this.init();
  }

  log(message, data = null) {
    if (this.debugMode) {
      console.log(`[CartDrawer Debug] ${message}`, data || '');
    }
  }

  error(message, error = null) {
    console.error(`[CartDrawer Error] ${message}`, error || '');
  }

  init() {
    this.log('Initializing Cart Drawer Event Handler...');

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupEventHandlers());
    } else {
      this.setupEventHandlers();
    }
  }

  setupEventHandlers() {
    this.log('Setting up event handlers...');

    // Find cart drawer element
    this.cartDrawer = document.querySelector("m-cart-drawer");

    if (!this.cartDrawer) {
      this.log('Cart drawer not found, retrying...');
      if (this.retryAttempts < this.maxRetries) {
        this.retryAttempts++;
        setTimeout(() => this.setupEventHandlers(), 1000);
        return;
      } else {
        this.error('Cart drawer element not found after maximum retries');
        return;
      }
    }

    this.log('Cart drawer found, setting up handlers');
    this.setupCartIconHandlers();
    this.setupCartDrawerHandlers();
    this.setupGlobalEventListeners();
    this.setupMutationObserver();
    this.setupVisibilityChangeHandler();

    this.isInitialized = true;
    this.log('Cart drawer event handlers initialized successfully');
  }

  setupCartIconHandlers() {
    const cartLinks = document.querySelectorAll(".m-cart-icon-bubble");
    this.log(`Found ${cartLinks.length} cart icon links`);

    cartLinks.forEach((cartLink, index) => {
      this.log(`Setting up cart link ${index + 1}`);

      // Remove existing event listeners by cloning
      const newCartLink = cartLink.cloneNode(true);
      cartLink.parentNode.replaceChild(newCartLink, cartLink);

      // Add comprehensive event listeners for better mobile support
      const eventTypes = ['click', 'touchstart', 'touchend'];

      eventTypes.forEach(eventType => {
        const handler = (event) => {
          this.log(`Cart icon ${eventType} event triggered`);
          event.preventDefault();
          event.stopPropagation();

          if (this.cartDrawer && typeof this.cartDrawer.open === 'function') {
            this.cartDrawer.open(event.currentTarget);
            this.log('Cart drawer opened via icon');
          } else {
            this.error('Cart drawer open method not available');
          }
        };

        newCartLink.addEventListener(eventType, handler, { passive: false });
        this.eventListeners.set(`cartLink_${index}_${eventType}`, handler);
      });
    });
  }

  setupCartDrawerHandlers() {
    if (!this.cartDrawer) return;

    // Enhanced click handler for remove buttons with immediate removal check
    const removeButtonHandler = (event) => {
      const removeButton = event.target.closest('.m-cart-remove-button, .cart-remove-button, [data-cart-remove]');
      if (removeButton) {
        this.log('Remove button clicked - triggering immediate removal check');

        // Immediate check (no delay)
        if (this.cartDrawer.checkCartTotalForRemoval) {
          this.cartDrawer.checkCartTotalForRemoval();
        }

        // Additional check after a short delay to ensure DOM is updated
        setTimeout(async () => {
          if (this.cartDrawer.checkCartTotalForRemoval) {
            await this.cartDrawer.checkCartTotalForRemoval();
          }
        }, 100);

        // Final check after longer delay
        setTimeout(async () => {
          if (this.cartDrawer.checkCartTotalForRemoval) {
            await this.cartDrawer.checkCartTotalForRemoval();
          }
        }, 500);
      }
    };

    // Add both click and touch events for better mobile support
    this.cartDrawer.addEventListener('click', removeButtonHandler, { passive: false });
    this.cartDrawer.addEventListener('touchstart', removeButtonHandler, { passive: false });

    this.eventListeners.set('removeButtonHandler', removeButtonHandler);
  }

  setupGlobalEventListeners() {
    // Enhanced MinimogEvents handling
    if (window.MinimogEvents && MinimogTheme.pubSubEvents) {
      this.log('Setting up MinimogEvents listeners');

      // Cart drawer open event
      const openCartHandler = () => {
        this.log('Cart drawer opened via MinimogEvents');
        this.handleCartOpen();
      };

      // Cart update event
      const cartUpdateHandler = () => {
        this.log('Cart updated via MinimogEvents');
        this.handleCartUpdate();
      };

      window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, openCartHandler);
      window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, cartUpdateHandler);

      this.eventListeners.set('openCartHandler', openCartHandler);
      this.eventListeners.set('cartUpdateHandler', cartUpdateHandler);
    } else {
      this.log('MinimogEvents not available, using fallback methods');
      this.setupFallbackEventListeners();
    }
  }

  setupFallbackEventListeners() {
    // Fallback for when MinimogEvents is not available
    this.log('Setting up fallback event listeners');

    // Listen for cart drawer visibility changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          if (target.classList.contains('m-cart-drawer--active')) {
            this.log('Cart drawer became active (fallback detection)');
            this.handleCartOpen();
          }
        }
      });
    });

    if (this.cartDrawer) {
      observer.observe(this.cartDrawer, { attributes: true, attributeFilter: ['class'] });
      this.eventListeners.set('fallbackObserver', observer);
    }
  }

  setupMutationObserver() {
    if (!this.cartDrawer) return;

    const removalObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
          this.log('Cart items removed detected via mutation observer');

          // Immediate check for removal
          if (this.cartDrawer.checkCartTotalForRemoval) {
            this.cartDrawer.checkCartTotalForRemoval();
          }

          // Additional checks with delays
          setTimeout(async () => {
            if (this.cartDrawer.checkCartTotalForRemoval) {
              await this.cartDrawer.checkCartTotalForRemoval();
            }
          }, 50);

          setTimeout(async () => {
            if (this.cartDrawer.checkCartTotalForRemoval) {
              await this.cartDrawer.checkCartTotalForRemoval();
            }
          }, 200);
        }

        // Also check for attribute changes that might indicate cart updates
        if (mutation.type === 'attributes') {
          const target = mutation.target;
          if (target.classList && target.classList.contains('m-cart-item')) {
            this.log('Cart item attribute changed, checking for removal');
            setTimeout(async () => {
              if (this.cartDrawer.checkCartTotalForRemoval) {
                await this.cartDrawer.checkCartTotalForRemoval();
              }
            }, 100);
          }
        }
      });
    });

    removalObserver.observe(this.cartDrawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-quantity', 'data-key']
    });

    this.eventListeners.set('removalObserver', removalObserver);
  }

  setupVisibilityChangeHandler() {
    // Handle page visibility changes (mobile browser tab switching)
    const visibilityHandler = () => {
      if (!document.hidden && this.cartDrawer) {
        this.log('Page became visible, checking cart state');
        setTimeout(() => {
          if (this.cartDrawer.checkCartTotalAndAddProduct) {
            this.cartDrawer.checkCartTotalAndAddProduct();
          }
        }, 500);
      }
    };

    document.addEventListener('visibilitychange', visibilityHandler);
    this.eventListeners.set('visibilityHandler', visibilityHandler);
  }

  handleCartOpen() {
    if (!this.cartDrawer || !this.cartDrawer.checkCartTotalAndAddProduct) {
      this.error('Cart drawer or checkCartTotalAndAddProduct method not available');
      return;
    }

    this.log('Handling cart open event');

    // Use requestAnimationFrame for better performance
    requestAnimationFrame(() => {
      setTimeout(async () => {
        try {
          await this.cartDrawer.checkCartTotalAndAddProduct();
          this.log('Cart total check completed');
        } catch (error) {
          this.error('Error in cart total check', error);
        }
      }, 150); // Slightly longer delay for mobile
    });
  }

  handleCartUpdate() {
    if (!this.cartDrawer || !this.cartDrawer.checkCartTotalAndAddProduct) {
      this.error('Cart drawer or checkCartTotalAndAddProduct method not available');
      return;
    }

    this.log('Handling cart update event');

    requestAnimationFrame(() => {
      setTimeout(async () => {
        try {
          await this.cartDrawer.checkCartTotalAndAddProduct();
          this.log('Cart update check completed');
        } catch (error) {
          this.error('Error in cart update check', error);
        }
      }, 250); // Longer delay for cart updates
    });
  }

  // Debug method to check cart state
  debugCartState() {
    if (!this.cartDrawer) {
      this.log('Cart drawer not found');
      return;
    }

    const cartItems = this.cartDrawer.querySelectorAll('.m-cart-item');
    const cartSubtotal = this.cartDrawer.querySelector('.m-cart__subtotal [data-cart-subtotal-price]');
    const hasFreeProduct = this.cartDrawer.querySelector('[data-variant-id="51934484169004"]');

    this.log('=== CART DEBUG STATE ===');
    this.log(`Cart items count: ${cartItems.length}`);
    this.log(`Cart subtotal: ${cartSubtotal ? cartSubtotal.textContent : 'Not found'}`);
    this.log(`Free product in cart: ${hasFreeProduct ? 'Yes' : 'No'}`);
    this.log(`Cart drawer active: ${this.cartDrawer.classList.contains('m-cart-drawer--active')}`);
    this.log(`Event listeners count: ${this.eventListeners.size}`);
    this.log('========================');
  }

  // Method to manually trigger cart check (for debugging)
  manualCartCheck() {
    this.log('Manual cart check triggered');
    if (this.cartDrawer && this.cartDrawer.checkCartTotalAndAddProduct) {
      this.cartDrawer.checkCartTotalAndAddProduct();
    }
  }

  // Cleanup method
  destroy() {
    this.log('Destroying cart drawer event handler');
    this.eventListeners.forEach((handler, key) => {
      if (key.includes('observer')) {
        handler.disconnect();
      } else {
        // Remove event listeners if possible
        this.log(`Cleaning up listener: ${key}`);
      }
    });
    this.eventListeners.clear();
  }
}

// Initialize the enhanced event handler
const cartDrawerEventHandler = new CartDrawerEventHandler();

// Expose debug methods to global scope for console access
window.cartDrawerDebug = {
  checkState: () => cartDrawerEventHandler.debugCartState(),
  manualCheck: () => cartDrawerEventHandler.manualCartCheck(),
  enableDebug: () => cartDrawerEventHandler.debugMode = true,
  disableDebug: () => cartDrawerEventHandler.debugMode = false,
  destroy: () => cartDrawerEventHandler.destroy(),

  // New methods for testing immediate removal
  testRemoval: async () => {
    const cartDrawer = document.querySelector("m-cart-drawer");
    if (cartDrawer && cartDrawer.checkCartTotalForRemoval) {
      console.log('[Debug] Testing immediate removal...');
      await cartDrawer.checkCartTotalForRemoval();
    } else {
      console.error('[Debug] Cart drawer or removal method not found');
    }
  },

  forceRemoval: async () => {
    const cartDrawer = document.querySelector("m-cart-drawer");
    if (cartDrawer && cartDrawer.removeSpecialProductFromCart) {
      console.log('[Debug] Force removing special product...');
      await cartDrawer.removeSpecialProductFromCart();
    } else {
      console.error('[Debug] Cart drawer or removal method not found');
    }
  },

  simulateRemoveButton: () => {
    const removeButton = document.querySelector('.m-cart-remove-button, .cart-remove-button, [data-cart-remove]');
    if (removeButton) {
      console.log('[Debug] Simulating remove button click...');
      removeButton.click();
    } else {
      console.log('[Debug] No remove button found');
    }
  }
};

// Legacy DOMContentLoaded handler for backward compatibility
document.addEventListener('DOMContentLoaded', function () {
  console.log('[CartDrawer] Legacy DOMContentLoaded handler - using enhanced handler instead');
});